import React from 'react';
import { Link } from "react-router-dom";
import Projects from "../../api/projects";
import arrow from '../../images/right-arrow-2.svg';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ProjectSectionS2 = (props) => {



    return (
        <section className={"" + props.hclass}>
            <div className="container-fulid">
                <div className="title">
                    <h2 className="fade_bottom">Our Creative Works</h2>
                    <p className="fade_bottom">Blaze is a trailblazing architecture agency renowned for its
                        innovative approach to design, where creativity meets functionality. Blaze believes architecture
                        is personal. Each design tells the unique story of its clients.</p>
                </div>
                <div className="project-wrap">
                    {Projects.slice(4, 8).map((project, item) => (
                        <div className="project-card-s2 fade_bottom" key={item}>
                            <img src={project.pimg} alt="project-1" />
                            <img src={project.pimg} alt="project-1" />
                            <div className="content">
                                <h2><Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>{project.title}</Link></h2>
                                <span>{project.subtitle}</span>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="project-allBtn fade_bottom">
                    <Link onClick={ClickHandler} to="/projects" className="theme-btn">
                        <span>See All Projects</span>
                        <img src={arrow} alt="" /></Link>
                </div>
            </div>
        </section>
    )
}

export default ProjectSectionS2;





